import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/spots/south-sea/page.tsx");
